import { Country, CountryType, SiteAdapter } from '@spartacus/core';
import { Observable } from 'rxjs';

export abstract class CustomSiteAdapter extends SiteAdapter {
  /**
   * Abstract method used to get all countries from all basestores with optional type.
   */
  abstract loadCountriesAll(type?: CountryType): Observable<Country[]>;
}
